export const KEYBOARD_SHORTCUT_ACTIONS = [
  'select_tool', 'undo', 'redo', 'copy', 'paste', 'duplicate', 'save', 'select_all',
  'complete_polygon', 'undo_polygon_point', 'delete', 'resize_selection', 'rotate_selection',
  'move_selection', 'focus_search', 'open_shortcuts', 'zoom_in', 'zoom_out', 'pan',
  'close_account_menu', 'cancel_polygon', 'cancel_radius', 'cancel_drawing', 'clear_selection',
] as const;

export type KeyboardShortcutAction = typeof KEYBOARD_SHORTCUT_ACTIONS[number];
